// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MostRecentMemeContainer {
    animation: mostRecentMemeFadeIn 2s;
    margin-left: auto;
    margin-right: auto;
}

.mostRecentMemesContainerGlobal {
    background-color: var(--DarkBlue);
    border-radius: 0.5em;
    max-width: 1250px;
    margin-left: auto;
    margin-right: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Home/HomeContent/MostRecentMemesLogic/mostRecentMemes.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".MostRecentMemeContainer {\n    animation: mostRecentMemeFadeIn 2s;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.mostRecentMemesContainerGlobal {\n    background-color: var(--DarkBlue);\n    border-radius: 0.5em;\n    max-width: 1250px;\n    margin-left: auto;\n    margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
